import React from 'react';

import { HStack } from '@rtkwlf/fenrir-react';
import { type Ticket } from '@rtkwlf/rendall';
import type { QueryClient, QueryKey } from '@tanstack/react-query';

import { ContactErrorMessage } from '@packages/components/contact/contact-error-message/contact-error-message';
import type { TicketListQueryData } from '@packages/utils/queryKeyFactories/tickets';

import type { ActionType } from './ticketAction.constants';

export type TicketActionOption = {
  value: ActionType;
  text: string;
};

type UpdateTicketListUpdateProps = {
  queryKey: QueryKey;
  ticket: Ticket;
  queryClient: QueryClient;
};

export const updateTicketList = ({
  queryKey,
  ticket: newTicket,
  queryClient,
}: UpdateTicketListUpdateProps) => {
  queryClient.setQueryData<TicketListQueryData | undefined>(
    queryKey,
    (cached) => {
      if (cached?.pages.length) {
        const [cachedPage1, ...cachedPagesRest] = cached.pages;
        const newTickets = [...(cachedPage1.tickets ?? [])];
        const index = cachedPage1.tickets.findIndex(
          (_ticket) => _ticket.id === newTicket.id,
        );
        newTickets[index] = newTicket;
        return {
          pageParams: cached.pageParams,
          pages: [
            {
              ...cachedPage1,
              tickets: [...newTickets],
            },
            ...cachedPagesRest,
          ],
        };
      }
      return cached;
    },
  );
};

export const ActionErrorMessage: React.FC<{
  errorMessage: string | null | undefined;
  onClose: () => void;
}> = ({ errorMessage, onClose }) => {
  if (!errorMessage) return null;

  return (
    <HStack
      width="auto"
      borderColor="warningDefault"
      borderWidth="default"
      borderStyle="solid"
      borderRadius="default"
      backgroundColor="warningHighlight"
      padding="default"
      gap="medium"
      alignItems="flex-start"
      marginBottom="default"
    >
      <ContactErrorMessage
        onClose={onClose}
        errorMessage={errorMessage as string}
      />
    </HStack>
  );
};
